<template>
  <button
    class="btn-home btn btn-secondary bg-secondary border-gradient-glow-secondary text-secondary-gradient bg-opacity-05"
    type="button"
    @click="$emit('gohome')"
  >
    <i class="fa-solid fa-house"></i>
  </button>
</template>
<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";

.btn-home {
  height: 56px;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease;

  &:hover {
    background: $secondary !important;
  }
}
</style>
